import BaseComponent, { style } from '@/components/base';

export default class LoadingSpinnerComponent extends BaseComponent {
  constructor() {
    super();
  }

  render() {
    return `
                    ${style(`
                        /* The loading spinner circle */
                        .loading-spinner {
                            width: 50px; /* Size of the spinner */
                            height: 50px;
                            border: 5px solid #e0e0e0; /* Light gray border for the base */
                            border-top: 5px solid black; /* Indigo-500 for the rotating part */
                            border-radius: 50%; /* Makes it a perfect circle */
                            animation: spin 1s linear infinite; /* Apply the spin animation */
                            -webkit-animation: spin 1s linear infinite; /* For Safari compatibility */
                        }

                        /* Keyframes for the spinning animation */
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }

                        @-webkit-keyframes spin {
                            0% { -webkit-transform: rotate(0deg); }
                            100% { -webkit-transform: rotate(360deg); }
                        }
                    `)}
                    <div class="loading-spinner"></div>
                `;
  }
}
